import { useECommerceContext } from "@/components/Product/ECommerce/context/eCommerce.context";
import { useProductConfigurationContext } from "@/components/Product/ECommerce/context/productConfiguration.context";

const ProductConfiguration = () => {
    const {
        productConfiguration,
        setIsConfigurationValid,
        configuration,
        setConfiguration
    } = useProductConfigurationContext();
    const { paintConfiguratorPath, product } = useECommerceContext();

    const onConfigurationChange = (config: Partial<any>) =>
        setConfiguration((currentConfig: any) => ({
            ...currentConfig,
            ...config
        }));

    return (
        <>
            {productConfiguration && (
                <productConfiguration.visual
                    metaConfiguration={{
                        paintConfiguratorPath,
                        product
                    }}
                    configuration={configuration}
                    setConfigurationValid={setIsConfigurationValid}
                    onConfigurationChange={onConfigurationChange}
                />
            )}
        </>
    );
};

export { ProductConfiguration };
